import React, { useEffect, useState } from "react";
import { NavLink,  } from "react-router-dom";
import Header from "../../shared/Header/Header";
import Footer from "../Home/Footer/Footer";
import useAuth from "../Hooks/useAuth";


const Explore = () => {
  const {admin} = useAuth()
  const [explores, setExplores] = useState([]);
  // const [searchPro] = useSearchParams()
  // console.log('search', searchPro.get('search'))

   
  // const [searchCar, setSearchCar] = useState('');
  useEffect(() => {
    fetch("https://rocky-fjord-43160.herokuapp.com/products")
      .then((res) => res.json())
      .then((data) => {
        const reverseData = data.reverse();
        setExplores(reverseData)
      });
  }, []);

  // search a car on user
  //  const searchFilterCar = explores.filter(explore =>{
  //    return explore.title.toLowerCase().includes(searchCar.toLowerCase())
  //  })


   //  search products
  
    //  const min_price = srcProduct.get('min-price') === null ? '' : srcProduct.get('min-price') ;
    //  const mix_price = srcProduct.get('mix-price') === null ? '' : srcProduct.get('mix-price') ;
    //  const seacrh = srcProduct.get('search') === null ? '' : srcProduct.get('search') ;

    
   

  return (
    <div>
      <Header />  
      <div className="container-fluid">
        <h1 className="fw-bolder text-center mt-3" style={{ color: "green" }}>
          {" "}
          More <span className="bd-title">CAR's</span> Collection
        </h1>
          
          <form method="GET">       
                <input className="me-3" type="number" name="min-price" placeholder="min-price" />
                <input className="me-3" type="number" name="mix-price" placeholder="max-price" />
                <input className="me-3" type="text" name="search" placeholder="search car" />
                <button className="order-submit border rounded" type="submit">search</button>
          </form>
          

         {/* <div className="mt-5">
           <input type="text" placeholder="search your car" onChange={ e =>{setSearchCar(e.target.value)}}></input>
         </div> */}
        <div className="row pb-5">
          {explores?.map((explore, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <div className="card-group mt-3">
                <div className="card pb-3">
                  <img src={explore.image} alt="" />
                  <div className="card-body">
                    <h5 className="card-title fw-bolder">{explore.title}</h5>
                    <p className="card-text">{explore.description}</p>
                    <h5 className="text-center fw-bolder ">
                      Price: ${explore.price}
                    </h5>
                  </div>

                  {
                    !admin && <NavLink to={`/order/${explore._id}`} className="buy-now ">
                    <button className="card-btn w-75 rounded-pill shadow border border-warning p-1 fs-5 text-light bg-success fw-bolder mx-auto">
                      Buy Now
                    </button>
                   </NavLink>
                  }
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Explore;

